import React from "react";
import { getCbtLink } from "../../utils/portalLinks";

function CbtEntryLink({ children, path = "", ...props }) {
  return (
    <a {...props} href={getCbtLink(path)}>
      {children}
    </a>
  );
}

export default CbtEntryLink;